import { useEffect, useState } from "react";
import http from "services/httpService";

function useFetchClaims() {
  const [claims, setClaims] = useState();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchClaimsSummary();
  }, []);

  const fetchClaimsSummary = async () => {
    setLoading(true);
    try {
      const { data } = await http.get("/business/get_claims_metric_summary/");
      setClaims(data);
    } catch (e) {
      console.log(e, "error data");
    } finally {
      setLoading(false);
    }
  };
  return { claims, loading };
}

export default useFetchClaims;
